/*eslint perfectionist/sort-objects: "error"*/

export const enGb = {
  accountDetails: "Account details",
  accountIdentifier: "Account identifier",
  accountNotFound: "Account not found",
  accountNumber: "Account number",
  accountStatus: "Account status",
  additionalConfigurationForProcessingPayouts:
    "Additional configuration for processing payouts via ISX",
  apiClient: "API Client",
  bankAccountDetailsLikeIbanAndSwift:
    "Bank account details like IBAN and Swift code (BIC). Account number, sort code or PIX key can be displayed for particular currencies.",
  bsb: "BSB",
  cashManagement: "Cash management",
  cashManagementAccount: "Cash management account",
  cashManagementAccountHasBeenUpdated:
    "Cash management account has been updated",
  cashManagementProviderNameConfig: "Cash management {{providerName}} config",
  chooseProviderAndCurrencyToSetAccountDetails:
    "Choose provider and currency to set account details.",
  configurableProviders: "Configurable providers",
  configurationSettings: "Configuration settings",
  configurationStatus: "Configuration status",
  configureNotifications: "Configure notifications",
  connect: "Connect",
  connectIsDisabledForThisMerchant: "Connect is disabled for this merchant",
  creatingSettlementInitiated: "Settlement have been requested",
  editProviderConfig: "Edit provider config",
  enableSettlementBatches: "Enable settlement batches",
  enterYourAccountNumberAndBsbCode:
    "Enter your account number and BSB code to receive payments from AU bank accounts.",
  enterYourAccountNumberAndSortCode:
    "Enter your account number and sort code to receive payments from UK bank accounts.",
  enterYourAccountNumberAndSwiftCode:
    "Enter your account number (IBAN) and Swift code (BIC) to receive payments into this account.",
  failingNotificationAlertEmail: "Failing notifications alert e-mail",
  givenAccountCouldNotBeFound: "Given account could not be found",
  goBackToConnectSettings: "Go back to Connect settings",
  highRisk: "High risk",
  hmacKey: "HMAC key",
  iban: "IBAN",
  isxMerchantId: "ISX Merchant ID",
  isxPayoutConfiguration: "ISX payout configuration",
  isxPayoutConfigurationUpdated: "ISX payout configuration has been updated",
  isxPayoutStatus: "ISX payout status",
  isxProviderNotFound: "ISX provider not found",
  itIsRequiredToConfigureProviderConfiguration:
    "It is required to configure provider configuration before you create virtual account using selected provider.",
  locationAndAcceptedPayments: "Location and accepted payments",
  lowRisk: "Low Risk",
  masterAccountNumberIban: "Master account number (IBAN)",
  newVirtualAccount: "New virtual account",
  noConfigurableProviders: "No configurable providers",
  notificationSecret: "Notification secret",
  notificationsSecret: "Notifications secret",
  notificationsSettings: "Notifications settings",
  notificationStatus: "Notification status",
  notificationUrlHttps: "Notification URL (https)",
  noUnsettledOperations: "There are no unsettled transactions at the moment",
  openProviderConfiguration: "Open {{providerName}} provider configuration",
  privateKey: "Private key",
  provider: "Provider",
  providerConfig: "Provider config",
  providerConfigUpdated: "Provider config has been updated",
  providerName: "Provider name",
  providers: "Providers",
  reportNotifications: "Report notifications",
  reportNotificationsSettingsUpdatedSuccessfully:
    "Report notifications settings updated sucessfully",
  riskScore: "Risk score",
  selectCustomer: "Select customer",
  selectProviderFirstToChooseACurrency:
    "Select provider first to choose a currency",
  sendSettlementBatches: "Send settlement batches",
  settlementBatchesSent: "Settlement batches have been sent",
  settlementModel: "Settlement model",
  sortCode: "Sort code",
  subdomain: "Subdomain",
  swiftCodeBic: "Swift code (BIC)",
  thereAreNoConfigurableProvidersAtThisMoment:
    "There are no configurable providers at this moment.",
  toReceivePaymentsFromOtherCountries:
    "To receive payments from other countries",
  toViewConnectSelectCustomer:
    "To view Connect settings, please select a customer in the select customer menu in the upper left corner.",
  uniqueIdForApi: "Unique ID for API",
  updateNotificationsSettings: "Update notifications settings",
  virtualAccount: "Virtual account",
  virtualAccountCreatedSuccessfully: "Virtual account created successfully",
  virtualAccounts: "Virtual accounts",
  voltAccountId: "Volt Account ID",
  voltAdminIsNotAllowed:
    "Volt Admin is not allowed to initiate settlements on production",
  voltCanSendANotificationWhen:
    "Volt can send a notification when reports (e.g. for settlement of funds) are available\n",
  walletId: "Wallet ID",
  youDoNotHavePermissionSettlementBatches:
    "You do not have permission to manage settlement batches.",
  youDoNotHavePermissionToProvideISX:
    "You don't have permission to provide ISX payout configuration. Do talk to out support team if you think there is an issue.",
  yourNameForThisAccount: "Your name for this account",
};
